<template>
  <div class="ticket-analytics">
    <div>
      <el-row :gutter="15">
        <el-col :span="8">
          <el-card>
            <div slot="header">
              {{ $t('ticketAnalysics.totalTicketSolds') }}
            </div>
            <div class="statistics">
              {{ data.total_ticket_solds }}
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <div slot="header">
              {{ $t('ticketAnalysics.revenue') }}
            </div>
            <div class="statistics">
              {{ data.revenue }}
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <div slot="header">
              {{ $t('ticketAnalysics.checkedIn') }}
            </div>
            <div class="statistics">
              {{ data.checked_in_count }}
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div class="ticket-kinds-columns">
      <div class="header">
        <span class="title">{{ $t('ticketAnalysics.revenueByTicketType') }}</span>
        <el-button type='primary' @click="() => exportClick(selection)"><i class='el-icon-download'></i> {{ $t('bean.actionExport') }}</el-button>
      </div>
      <bean-table :height="null" :data="data.ticket_kinds || []" :columns="ticketKindsColumns()" :pagination="false"></bean-table>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { columnsExtend as ticketKindsColumnsExtend } from '../admin_grapes/ticket_kinds.js';

@Component
export default class TicketAnalysics extends Vue {
  @Prop(Number) ticketEventId;
  @Prop(String) eventTitle;

  data = {}

  ticketKindsColumns() {
    const columns = [
      {
        key: 'title',
        label: this.$t('model.ticketKind'),
        minWidth: 150,
      },
      'price_cents',
      'sold_capacity',
      'sold_amount',
    ]
    return ticketKindsColumnsExtend(columns);
  }

  async exportClick() {
    await this.$request.get(`/ticket_events/${this.ticketEventId}/analytics`, { is_export: true });
    this.$message.success(this.$t('exporting'));
  }

  async mounted() {
    const data = await this.$request.get(`/ticket_events/${this.ticketEventId}/analytics`);
    this.data = data;
  }
}
</script>

<style lang="scss">
  .ticket-analytics {
    .export-button {
      margin-bottom: 15px;
    }

    .el-row {
      margin-bottom: 20px;
    }

    .el-card {
      .el-card__header {
        padding: 10px;
        font-size: 14px;
        color: #909399;
        text-align: center;
        font-weight: bold;
      }

      .statistics {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
      }
    }

    .ticket-kinds-columns {
      margin-top: 40px;

      .header {
        display: flex;
        justify-content: space-between;
      }

      .title {
        font-size: 16px;
        color: #909399;
        font-weight: bold;
      }
    }
  }
</style>
